import { ChevronRightIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const jobs = [
  {
    id: 1,
    title: "Représentant.e",
    image:
      "https://qxidrfcclqstiadjauhz.supabase.co/storage/v1/object/sign/receptioncvs/offreemploirepresentant.jpg?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InN0b3JhZ2UtdXJsLXNpZ25pbmcta2V5X2I5N2FmODczLTRkNjctNGJkYi05ZTEzLTExZGE0NzQ4MjYwYiJ9.eyJ1cmwiOiJyZWNlcHRpb25jdnMvb2ZmcmVlbXBsb2lyZXByZXNlbnRhbnQuanBnIiwiaWF0IjoxNzQ4MjcyNTI1LCJleHAiOjE3Nzk4MDg1MjV9.q8PxkSvyohSJ9aHUV_4ddzjFm-oJHXsnoyuL58LW2YA",
    code: "Expert en ventes et relations clients",
  },
  {
    id: 2,
    title: "Programmeur.se-Analyste fullstack",
    image:
      "https://qxidrfcclqstiadjauhz.supabase.co/storage/v1/object/sign/receptioncvs/recrutementprogrammeur.jpg?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InN0b3JhZ2UtdXJsLXNpZ25pbmcta2V5X2I5N2FmODczLTRkNjctNGJkYi05ZTEzLTExZGE0NzQ4MjYwYiJ9.eyJ1cmwiOiJyZWNlcHRpb25jdnMvcmVjcnV0ZW1lbnRwcm9ncmFtbWV1ci5qcGciLCJpYXQiOjE3NDgyNzI1MTMsImV4cCI6MTc3OTgwODUxM30.vbbpZwiiLkZ9s-3nzTmfYstEMHVqzWSP9xd8b_YVAn4",
    code: "Maître de la transformation de café en code",
  },
  {
    id: 3,
    title: "Candidature spontanée",
    image:
      "https://qxidrfcclqstiadjauhz.supabase.co/storage/v1/object/sign/receptioncvs/recrutementprogrammeur.jpg?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InN0b3JhZ2UtdXJsLXNpZ25pbmcta2V5X2I5N2FmODczLTRkNjctNGJkYi05ZTEzLTExZGE0NzQ4MjYwYiJ9.eyJ1cmwiOiJyZWNlcHRpb25jdnMvcmVjcnV0ZW1lbnRwcm9ncmFtbWV1ci5qcGciLCJpYXQiOjE3NDgyNzI1MTMsImV4cCI6MTc3OTgwODUxM30.vbbpZwiiLkZ9s-3nzTmfYstEMHVqzWSP9xd8b_YVAn4",
    code: "Envoyez-nous votre CV",
  },
];

export default function CareersPage() {
  const [selected, setSelected] = useState(jobs[0]);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    motivation: "",
    notes: "",
    file: null,
  });

  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const submitForm = async () => {
    if (!validateForm()) return;

    const data = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value) data.append(key, value);
    });
    data.append("jobTitle", selected.title);

    const res = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/JobApplication/apply`,
      {
        method: "POST",
        body: data,
      }
    );

    if (res.ok) {
      setSubmitted(true);
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        motivation: "",
        notes: "",
        file: null,
      });
    }
  };

  const validateForm = () => {
    if (!form.firstName.trim() || !form.lastName.trim()) {
      alert(t("recruitment.errorName"));
      return false;
    }

    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email)) {
      alert(t("recruitment.errorEmail"));
      return false;
    }

    if (!form.file || !form.file.type.includes("pdf")) {
      alert(t("recruitment.errorFile"));
      return false;
    }

    return true;
  };

  return (
    <div className="bg-gray-100 min-h-screen text-primary">
      <div className="">
        <h1 className="text-4xl font-bold mb-8 text-center text-gray-800 mt-8">
          {t("recruitment.title")}
        </h1>
        <h2 className="text-lg text-center text-gray-800 mb-8 md:w-1/2 w-full px-4 mx-auto">
          {t("recruitment.subtitle")}
        </h2>
        <div className="flex justify-center">
          <button
            onClick={() => {
              const el = document.getElementById("apply-form");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="mb-8 px-6 py-3 bg-primary text-white font-semibold rounded-full hover:bg-primary/90 transition w-full max-w-xs"
          >
            {t("recruitment.applyNow")}{" "}
            <ChevronRightIcon className="w-5 h-5 inline ml-1" />
          </button>
        </div>
      </div>

      <div className="min-h-screen bg-accent p-8">
        <div className="grid md:grid-cols-3 gap-6">
          <div className="col-span-2 md:col-span-1 space-y-2 w-full">
            {jobs.map((job) => (
              <button
                key={job.id}
                onClick={() => {
                  setSelected(job);
                  setSubmitted(false);
                }}
                className={`w-full text-left px-4 py-3 rounded-lg shadow-sm transition ${
                  selected.id === job.id
                    ? "bg-bgCyan text-white"
                    : "bg-white hover:bg-gray-400 text-gray-800"
                }`}
              >
                <div className="font-semibold">{job.title}</div>
                <div
                  className={`text-sm italic ${
                    selected.id === job.id ? "text-gray-300" : "text-gray-600"
                  }`}
                >
                  {job.code}
                </div>
              </button>
            ))}
          </div>

          <div className="col-span-2 bg-white rounded-lg shadow flex flex-col justify-between">
            <div>
              <img
                src={selected.image}
                alt={selected.title}
                className="w-full max-w-2/3 mx-auto rounded shadow object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="m-8 bg-white p-6 rounded-lg shadow-md max-w-3xl mx-auto text-primary"
        id="apply-form"
      >
        <h2 className="text-2xl font-bold mb-4 text-gray-800">
          {t("recruitment.applyFor")}{" "}
          <span className="text-primary">{selected.title}</span>
        </h2>

        {submitted ? (
          <p className="text-green-600 font-medium">
            {t("recruitment.success")}
          </p>
        ) : (
          <>
            <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  {t("recruitment.firstName")}
                </label>
                <input
                  type="text"
                  className="input input-bordered w-full"
                  value={form.firstName}
                  onChange={(e) => handleChange("firstName", e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  {t("recruitment.lastName")}
                </label>
                <input
                  type="text"
                  className="input input-bordered w-full"
                  value={form.lastName}
                  onChange={(e) => handleChange("lastName", e.target.value)}
                />
              </div>
            </div>

            <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  {t("recruitment.email")}
                </label>
                <input
                  type="email"
                  className="input input-bordered w-full"
                  value={form.email}
                  onChange={(e) => handleChange("email", e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  {t("recruitment.phone")}
                </label>
                <input
                  type="tel"
                  className="input input-bordered w-full"
                  value={form.phone}
                  onChange={(e) => handleChange("phone", e.target.value)}
                  placeholder="418-555-0123"
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-600 mb-1">
                {t("recruitment.motivation")}
              </label>
              <textarea
                className="textarea textarea-bordered w-full"
                rows={4}
                value={form.motivation}
                onChange={(e) => handleChange("motivation", e.target.value)}
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-600 mb-1">
                {t("recruitment.cv")}
              </label>
              <input
                type="file"
                accept=".pdf,.doc,.docx"
                className="file-input w-full"
                onChange={(e) => handleChange("file", e.target.files[0])}
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-600 mb-1">
                {t("recruitment.notes")}
              </label>
              <textarea
                className="textarea textarea-bordered w-full"
                rows={3}
                value={form.notes}
                onChange={(e) => handleChange("notes", e.target.value)}
              />
            </div>

            <div className="text-center">
              <button
                onClick={submitForm}
                className={`bg-primary text-white rounded-full p-4 ${
                  loading ? "loading" : ""
                }`}
                disabled={loading}
              >
                {t("recruitment.submit")}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
